

























































































































































































































































interface Survey {
  salesAmount: string | undefined;
  withdrawedAmount: string | undefined;
  waitingWithdrawedAmount: string | undefined;
  waitingSettledAmount: string | undefined;
}
interface Form {
  type: string | undefined;
  relevanceId: string | undefined;
  orderId: string | undefined;
  firstTime: Moment[];
  timeType: string | undefined;
  secondTime: Moment[];
  search: string | undefined;
  mobile: string | undefined;
  status: string | undefined;
}
import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { date } from '@/util/adapter';
import moment, { Moment } from 'moment';
const uuidv4 = require('uuid/v4');
const { VUE_APP_API } = process.env;
const API = {
  capitalSurvey: `${VUE_APP_API}/qy/capital/survey`,
  capitalList: `${VUE_APP_API}/qy/capital/list-detail`,
  capitalExport: `${VUE_APP_API}/qy/capital/export?`,
  withdrawList: `${VUE_APP_API}/qy/withdraw/list-detail`,
  withdrawExport: `${VUE_APP_API}/qy/withdraw/export?`,
};

const TYPE_LIST = [
  {
    _key: uuidv4(),
    label: '收入-订单支付',
    value: '1',
  },
  {
    _key: uuidv4(),
    label: '支出-订单退款',
    value: '2',
  },
  {
    _key: uuidv4(),
    label: '支出-奖金提现',
    value: '3',
  },
  {
    _key: uuidv4(),
    label: '支出-手续费',
    value: '4',
  },
  {
    _key: uuidv4(),
    label: '收入-提现失败',
    value: '5',
  },
  {
    _key: uuidv4(),
    label: '收入-手续费退回',
    value: '6',
  },
];

const TIME_TYPE = [
  {
    _key: uuidv4(),
    label: '申请时间',
    value: 'apply_time',
  },
  {
    _key: uuidv4(),
    label: '付款时间',
    value: 'pay_time',
  },
];

const STATUS_LIST = [
  {
    _key: uuidv4(),
    label: '全部',
    value: undefined,
  },
  {
    _key: uuidv4(),
    label: '待审核',
    value: '5',
  },
  {
    _key: uuidv4(),
    label: '待支付',
    value: '10',
  },
  {
    _key: uuidv4(),
    label: '结束',
    value: '15',
  },
  {
    _key: uuidv4(),
    label: '审核不通过',
    value: '20',
  },
  {
    _key: uuidv4(),
    label: '支付不通过',
    value: '25',
  },
  {
    _key: uuidv4(),
    label: '支付失败',
    value: '30',
  },
];
@Component
export default class FinanceList extends Vue {
  isLoading: boolean = false;
  tabIndex: any = '1';
  form: Form = {
    type: undefined,
    relevanceId: undefined,
    orderId: undefined,
    firstTime: [],
    timeType: undefined,
    secondTime: [],
    search: undefined,
    mobile: undefined,
    status: undefined,
  };
  survey: Survey = {
    salesAmount: undefined,
    withdrawedAmount: undefined,
    waitingWithdrawedAmount: undefined,
    waitingSettledAmount: undefined,
  };
  typeList: any = TYPE_LIST;
  timeType: any = TIME_TYPE;
  statusList: any = STATUS_LIST;
  statusListObj: any = {};
  sendData: any = {};
  page: any = '';
  financeData: any = {};
  queryUrl: string = '';

  getSendData() {
    const sendData: any = {};
    const form = this.form;
    const firstStartTime: Moment = form.firstTime[0];
    const firstEndTime: Moment = form.firstTime[1];
    const secondStartTime: Moment = form.secondTime[0];
    const secondEndTime: Moment = form.secondTime[1];
    sendData.page = this.page;
    if (this.tabIndex === '1') {
      sendData.type = form.type;
      sendData.relevance_no = form.relevanceId || form.orderId;
      sendData.start_time = firstStartTime ? date(firstStartTime) : undefined;
      sendData.end_time = firstEndTime ? date(firstEndTime) : undefined;
    } else {
      sendData.time_type = form.timeType;
      sendData.search = form.search || form.mobile;
      sendData.start_time =
        form.timeType && secondStartTime ? date(secondStartTime) : undefined;
      sendData.end_time =
        form.timeType && secondEndTime ? date(secondEndTime) : undefined;
      sendData.check_status = form.status;
    }
    this.sendData = sendData;
  }

  query(page: number = 1) {
    this.page = page;
    this.isLoading = true;
    this.getSendData();
    this.$axios
      .get(this.queryUrl, { params: this.sendData })
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error !== 0) {
          this.$message.error(remote.message);
          return;
        }
        const data = remote.data || {};
        this.financeData = data;
        this.financeData.data.forEach((item: any) => {
          item._key = uuidv4();
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  paginationOption(data: RemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.per_page}条`,
      pageSize: data.per_page || 1,
      current: data.current_page || 1,
    };
  }

  onChange(value: string) {
    this.tabIndex = value;
    const type = this.tabIndex === '1' ? 'capital' : 'withdraw';
    this.submit(type);
  }

  getSurveyMsg() {
    this.$axios.get(API.capitalSurvey).then((res: AxiosResponse) => {
      const remote = res.data;
      if (remote.error !== 0) {
        this.$message.error(remote.message);
        return;
      }
      const data = remote.data || {};
      this.survey = getSurveyData(remote.data);
    });
  }

  detailText(time: any) {
    const newData = new Date().getTime();
    const activeTime = new Date(time).getTime();
    if (newData - activeTime <= 604800000) {
      // 在点支付通过后168小时内 == 支付失败
      return '支付失败';
    } else {
      return '查看';
    }
  }

  submit(type: any) {
    this.queryUrl = type === 'capital' ? API.capitalList : API.withdrawList;
    this.getSendData();
    this.query();
  }

  exportData(type: any) {
    this.getSendData();
    const params = this.sendData;
    let url = type === 'capital' ? API.capitalExport : API.withdrawExport;
    for (const key in params) {
      if (key && params[key]) {
        url += `&${key}=${params[key]}`;
      }
    }
    window.location.href = url;
  }

  created() {
    this.tabIndex = this.$route.query.index ? this.$route.query.index : '1';
    this.form.status = this.$route.query.status
      ? String(this.$route.query.status)
      : undefined;
    this.onChange(this.tabIndex);
    this.getSurveyMsg();
    this.statusList.forEach((item: any) => {
      this.statusListObj[item.value] = item.label;
    });
  }
}

function getSurveyData(remote: any = {}): Survey {
  return {
    salesAmount: remote.sales_amount,
    withdrawedAmount: remote.withdrawed_amount,
    waitingWithdrawedAmount: remote.waiting_withdrawed_amount,
    waitingSettledAmount: remote.waiting_settled_amount,
  };
}
